import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { EditListingIcon } from '@components/IRIS/common/irisIcons';
import SwitchCustom from '@components/common/switch';
import { SAFARI } from '@utility/enums/browsers';
import { fnBrowserDetect } from '@utility/browsers';
import { clearGlobalSelection } from '@utility/clearGlobalSelection';
import TutorialButton from '@components/userDocuments/editDocument/editResume/tutorials/TutorialVideos/tutorialButton';
import { tutorialLinks } from '@components/userDocuments/editDocument/editResume/tutorials/TutorialVideos/tutorials';
import { TYPING_DEBOUNCE } from '../../../../../../../../constants/debounce';
import Actions from '../../../../../../../../store/actions';
import breakpointsMinWidth from '../../../../../../../../styling/breakpointsMinWidth';
import getSectionStyle from '../../../../../../../../styling/getSectionStyle';
import {
  PrimaryDark,
  PrimaryDarkRGBA,
} from '../../../../../../../../styling/theme';
import KEY_CODES from '../../../../../editJournal/constants/keyCodes';
import renderDict from '../../../../../editResume/EditSpace/EditorPane/RenderContent/EditorSection/utils/renderDict';
import EditSectionTitle from './editSectionTitle';
import updateUserPreferencesSectionTitle from './updateUserPreferencesSectionTitle';

const TitleWrapperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  grid-column: 1/-1;
  pointer-events: all;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #000000;

  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 16px;
    line-height: 24px;
  }

  ${(props) => {
    const { sectionKey } = props;
    if (sectionKey === 'skills' || sectionKey === 'languages') {
      return css`
        width: 100%;
        gap: 8px;

        @media ${breakpointsMinWidth.mobileMicroLg} {
          width: 350px;
        }

        @media ${breakpointsMinWidth.tabletSm} {
          width: 444px;
        }

        @media ${breakpointsMinWidth.tabletLg} {
          width: 457px;
        }

        @media ${breakpointsMinWidth.desktopSm} {
          width: 511px;
        }
        @media ${breakpointsMinWidth.desktopMd} {
          width: 672px;
        }
      `;
    }
    return null;
  }}
`;

export const TitleWrapper = styled.div`
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  pointer-events: all;
  cursor: default;
  white-space: nowrap;
  max-width: 89%;

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'personalInfo') {
      return css`
        max-width: 100%;
        ${getSectionStyle[nodeType]};
      `;
    }
    if (nodeType) {
      return css`
        ${getSectionStyle[nodeType]};
      `;
    }
    return null;
  }}
`;

const Wrapper = styled.div`
  display: flex;
  width: 50%;

  ${(props) => {
    const { sectionKey } = props;
    if (sectionKey === 'skills' || sectionKey === 'languages') {
      return css`
        display: flex;
        overflow: hidden;
        width: 60%;
      `;
    }
    return null;
  }}
`;

const EditWrapper = styled.div`
  cursor: pointer;
  margin-left: 2px;
  margin-top: -1px;
  width: 14px;
  height: 14px;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;

  &:hover {
    background-color: ${PrimaryDarkRGBA(0.1)};
  }

  @media ${breakpointsMinWidth.desktopMd} {
    width: 18px;
    height: 18px;
    border-radius: 4px;

    .rename-editor-section {
      width: 14px;
      height: 14px;
    }
  }
`;

export const EditTitle = styled.input`
  height: 36px;
  width: 100%;
  border: none;
  border-bottom: 2px solid ${PrimaryDark};
  font-size: 12px;
  color: #000000;
  padding: 0 10px;
  border-radius: 2px;

  &:focus {
    outline: none;
  }

  ${(props) => {
    const { nodeType } = props;
    if (nodeType === 'skills' || nodeType === 'summary') {
      return css`
        width: 100%;
      `;
    }
    return null;
  }}
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 14px;
  }
`;

const RatingWrapper = styled.div`
  text-align: left;
  cursor: default;
  white-space: nowrap;
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 4px;
`;

const Span = styled.span``;

const RatingText = styled(Span)``;

const DivWrapper = styled.div`
  display: flex;
  ${({ sectionKey }) => {
    if (sectionKey === 'skills' || sectionKey === 'languages') {
      return `
      margin-right:-40px
   
      @media ${breakpointsMinWidth.tabletLg} {
           margin-right:-6px
      }
      @media ${breakpointsMinWidth.desktopSm} {
          margin-right:-32px
      }
      @media ${breakpointsMinWidth.desktopMd} {
          margin-right:-40px
      }
        `;
    }
    return '0';
  }};
`;

class Title extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      updateTitle: props.title,
      prevUpdatedTitle: '',
    };
  }

  handleEditing = () => {
    const { setTitleEditing } = this.props;
    this.setState({ isEditing: true });
    setTitleEditing(true);
  };

  handleRating = (checked) => {
    const { updateUserPreferences, userPreferences, formatType, sectionKey } =
      this.props;

    updateUserPreferences({
      userPreferences: {
        ...userPreferences,
        showRatings: { ...userPreferences.showRatings, [sectionKey]: checked },
      },
      formatType,
    });
  };

  handleUpdateUserPreferences = (title) => {
    const { updateUserPreferences, userPreferences, sectionKey, formatType } =
      this.props;
    updateUserPreferencesSectionTitle({
      title,
      updateUserPreferences,
      userPreferences,
      sectionKey,
      formatType,
    });
  };

  handleChange = (e) => {
    clearTimeout(this.timer);
    const { value } = e.target;
    this.timer = setTimeout(() => {
      this.setState({ updateTitle: value });
      this.handleUpdateUserPreferences(value);
    }, TYPING_DEBOUNCE);
  };

  handleOnKeyDown = (e) => {
    if (e.which === KEY_CODES.TAB) {
      if (fnBrowserDetect() === SAFARI) {
        clearGlobalSelection();
      }
      const { editor, setTitleEditing } = this.props;
      setTimeout(() => {
        setTitleEditing(false);
      });
      e.preventDefault();
      this.setState({ isEditing: false });

      const {
        value: { document },
      } = editor;

      const [organization] = document.nodes.toArray();
      const [organizationFirstChild] = organization.nodes.toArray();
      let organizationFirstGrandChildren = null;
      if (organizationFirstChild && organizationFirstChild.nodes) {
        organizationFirstGrandChildren = organizationFirstChild.nodes.toArray();
      }

      if (
        organization &&
        organization.type &&
        organization.type === 'skill_organization'
      ) {
        editor.focus().moveToRangeOfNode(organizationFirstChild);
        return;
      }

      if (
        organization &&
        organization.type &&
        organization.type.includes('_organization')
      ) {
        editor.focus().moveToRangeOfNode(organizationFirstGrandChildren[1]);
        return;
      }

      if (
        (organization &&
          organization.type &&
          organization.type === 'summary') ||
        organization.type === 'full_name' ||
        renderDict[organization.type] === 'array_item'
      ) {
        editor.focus().moveToRangeOfNode(organization);
        return;
      }
    }
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.which === KEY_CODES.Z || e.which === KEY_CODES.Y)
    ) {
      e.stopPropagation();
    }

    if ((e.ctrlKey || e.metaKey) && e.which === KEY_CODES.S) {
      const { userPreferences } = this.props;

      const {
        leftPane: {
          activeElement: { title: updatedActiveElementTitle },
        },
      } = userPreferences;
      if (updatedActiveElementTitle) {
        this.setState({ prevUpdatedTitle: updatedActiveElementTitle });
      }
    }
  };

  handleUpdateTitle = (defaultTitle) => {
    this.setState({ updateTitle: defaultTitle });
  };

  handleUpdateIsEditing = (value) => {
    this.setState({ isEditing: value });
  };

  render() {
    const { isEditing, updateTitle, prevUpdatedTitle } = this.state;
    const { sectionKey, title, setTitleEditing, showRatings } = this.props;
    const getTutorialLink = (sectionName) =>
      tutorialLinks[sectionName] || tutorialLinks.default;
    const tutorialSections = [
      'skills',
      'personalInfo',
      'workExperience',
      'education',
      'projects',
    ];
    const getSectionTutorialTitle = () => {
      return `${updateTitle?.trim() || prevUpdatedTitle?.trim() || ''} section tutorial`;
    };

    const getSectionTutorialLabel = () => `${sectionKey} tutorial`;
    return (
      <>
        <TitleWrapperContainer sectionKey={sectionKey}>
          {isEditing ? (
            <EditSectionTitle
              inputRef={this.inputRef}
              sectionKey={sectionKey}
              title={title}
              isEditing={isEditing}
              updateTitle={updateTitle}
              prevUpdatedTitle={prevUpdatedTitle}
              setTitleEditing={setTitleEditing}
              handleChange={this.handleChange}
              handleOnKeyDown={this.handleOnKeyDown}
              handleUpdateTitle={this.handleUpdateTitle}
              handleUpdateIsEditing={this.handleUpdateIsEditing}
              handleUpdateUserPreferences={this.handleUpdateUserPreferences}
            />
          ) : (
            <Wrapper sectionKey={sectionKey}>
              <TitleWrapper nodeType={sectionKey}>
                {updateTitle || prevUpdatedTitle}
              </TitleWrapper>
              <EditWrapper
                title="Rename Section"
                className="editTitle"
                onClick={this.handleEditing}
              >
                <EditListingIcon
                  width={12}
                  height={12}
                  className="rename-editor-section"
                />
              </EditWrapper>
            </Wrapper>
          )}
          <DivWrapper sectionKey={sectionKey}>
            {(sectionKey === 'skills' || sectionKey === 'languages') && (
              <RatingWrapper>
                <RatingText>Rating</RatingText>
                <SwitchCustom
                  onChange={this.handleRating}
                  isSelected={showRatings?.[sectionKey] || false}
                />
              </RatingWrapper>
            )}
            {tutorialSections.includes(sectionKey) && (
              <TutorialButton
                title={getSectionTutorialTitle(
                  updateTitle,
                  prevUpdatedTitle,
                  sectionKey,
                )}
                label={getSectionTutorialLabel(sectionKey)}
                tutorialLink={getTutorialLink?.(sectionKey) || ''}
              />
            )}
          </DivWrapper>
        </TitleWrapperContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userPreferences: state.editResumeFormReducer.userPreferences,
  showRatings: state.editResumeFormReducer.userPreferences.showRatings,
  formatType: state.editResumeFormReducer.formatType,
});

const mapDispatchToProps = (dispatch) => ({
  updateUserPreferences: (params) => {
    dispatch(Actions.editDocumentFormActions.updateUserPreferences(params));
  },
});

Title.defaultProps = {
  setTitleEditing: () => {},
  showRatings: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Title);
